<nz-modal [(nzVisible)]="this.isVisible"
          [nzTitle]="modalTitle"
          [nzCentered]="true"
          [nzClassName]="'modal-notes'"
          [nzContent]="modalContent"
          [nzFooter]="modalFooter"
          [nzWidth]="'40%'"
          (nzOnCancel)="onCloseModalAddRow(true)">


  <ng-template #modalTitle>
    <div class="container-steps-modal" @fadeInAnimation>
      <h2 class="text-title-md-bold first-letter-upper">Agrega un alimento</h2>
      <p class="text-info">Puede buscar y agregar el alimento al que el paciente es alérgico</p>
    </div>
  </ng-template>

  <ng-template #modalContent>
    <div class="container-modal" @fadeInAnimation>
      <form [formGroup]="allergyForm" novalidate>
        <div nz-row [nzGutter]="16">
          <div nz-col nzSpan="24">
            <div class="input-label-form">Alimento</div>
            <app-ingredient-selector
              [hasCategoryFilter]="true"
              [hasIngredientName]="true"
              [showForm]="true"
              [resetAfterSelect]="false"
              [excludedIngredients]="this.getAllergyIds"
              (selected)="onSelectedAllergyIngredient($event)"
            ></app-ingredient-selector>
            <app-message-field [field]="allergyForm.get('ingredientName')"></app-message-field>
          </div>
          <div nz-col nzSpan="24" class="mt-xs">
            <div class="input-label-form">Fecha en que se presentó la alergia</div>
            <nz-date-picker formControlName="allergyDate"
                            [nzFormat]="this.platformConfig.FORMAT.DATE.DDMMYYYY"></nz-date-picker>
            <app-message-field [field]="allergyForm.get('allergyDate')"></app-message-field>
          </div>
        </div>
      </form>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <div class="container-footer-modal" @fadeInAnimation>
      <button
        style="margin-right: 5px;"
        (click)="onCloseModalAddRow(true)"
        nz-button nzType="cancel">CANCELAR
      </button>
      <button
        (click)="onCloseModalAddRow(false)"
        [disabled]="!allergyForm.valid"
        nz-button nzType="primary">{{ 'GUARDAR' }}</button>
    </div>
  </ng-template>
</nz-modal>
